export default __webpack_public_path__ + "static/media/Backgroundbackground3.f2ee6f4e.png";